import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "account__left-import-err"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
    class: "account__left-import-wrapper",
    style: {"padding":"10px 0"}
  }, [
    _createElementVNode("label", {
      onDrop: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dropFile && _ctx.dropFile(...args))),
      class: "profile__run",
      for: "importJSON"
    }, "Import words from JSON", 32),
    _createElementVNode("input", {
      id: "importJSON",
      ref: "files",
      accept: ".json",
      type: "file",
      class: "account__left-import profile__run",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.importHandle && _ctx.importHandle(...args)))
    }, null, 544),
    (_ctx.isErr)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Файл поврежден, и не может быть загружен"))
      : _createCommentVNode("", true),
    (_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.fileInfo.name), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.fileInfo.lists) + " списков", 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.fileInfo.wordsLength) + " слов", 1),
          _createElementVNode("button", {
            class: "profile__run",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadWords && _ctx.loadWords(...args)))
          }, "Загрузить !")
        ]))
      : _createCommentVNode("", true)
  ], 32))
}